import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "play-circle",
  "use": "play-circle-usage",
  "viewBox": "0 0 512 512",
  "content": "<symbol viewBox=\"0 0 512 512\" id=\"play-circle\"><path d=\"M0 262v-9-7c0-9 0-19 3-28 3-26 10-48 23-71C54 86 102 45 163 19c26-13 55-16 83-19h39c25 3 51 10 73 19 52 23 93 58 119 109 19 35 32 74 32 115v23c0 19-3 38-10 54-13 51-41 96-83 131-45 35-96 58-154 58h-22c-13 0-26-3-38-3-29-7-58-16-84-32-35-23-64-52-86-87-16-35-29-77-32-118v-7zm38-6c0 64 26 118 71 160s102 61 163 58c54-4 102-26 141-68 45-48 64-102 61-166-7-106-100-211-237-198-109 6-199 96-199 214zm164 19v93c0 6 3 10 9 13 3 3 10 0 13-3 10-10 22-20 32-29 29-26 58-51 90-77 12-13 12-22 0-32-16-10-26-19-39-29-19-19-38-35-61-54-9-7-16-16-25-23-10-6-19-3-19 7v134z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/play-circle.svg
// module id = 203
// module chunks = 0